import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, Tooltip } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
const WholesaleOverviewStatus = (props) => {
    const { ShowEndDateStatus, DaysUntilEndDate, DaysUntilEndDateStatus, StatusName } = props;
    if (!DaysUntilEndDateStatus || !ShowEndDateStatus) {
        return _jsx(_Fragment, {});
    }
    return (_jsxs(Grid, { container: true, spacing: 1, direction: "row", justifyContent: "space-between", alignItems: "center", children: [_jsx(Grid, { item: true, children: DaysUntilEndDate }), _jsx(Grid, { item: true, children: _jsx(Tooltip, { placement: "bottom", arrow: true, title: StatusName, children: _jsx(Skeleton, { style: { backgroundColor: DaysUntilEndDateStatus }, variant: "circle", width: 16, height: 16, animation: false }) }) })] }));
};
export { WholesaleOverviewStatus };
//# sourceMappingURL=WholesaleOverviewStatus.js.map